import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React from 'react';
import ProgressCircle from './ProgressCircle.js';

var _templateObject;
var StyledStepperHeader = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n    @media (max-width: 500px) {\n      flex-direction: column;\n    }\n"])));
var StepperHeader = function StepperHeader(_ref) {
  var activeStep = _ref.activeStep,
    stepTitles = _ref.stepTitles;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledStepperHeader, {
    role: "list"
  }, stepTitles.map(function (title, index) {
    return /*#__PURE__*/React.createElement(ProgressCircle, {
      key: index,
      active: index === activeStep,
      stepNumber: index + 1,
      title: title,
      completed: activeStep > index,
      totalSteps: index
    });
  })));
};

export default StepperHeader;
